import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function IdeaStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M9.75 21.0005C9.75 21.967 11.0335 22.7505 11.5 22.7505H12.5C12.9665 22.7505 14.25 21.967 14.25 21.0005L9.75 21.0005Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 5.49622C8.3941 5.49622 5.47093 8.41939 5.47093 12.0253C5.47093 14.3315 6.66398 16.1339 8.41857 17.2501H15.5815C17.336 16.1339 18.5291 14.3315 18.5291 12.0253C18.5291 8.41939 15.6059 5.49622 12 5.49622ZM15.1763 18.2501H8.82375L8.9415 19.6383C8.96781 19.7699 9.01004 19.8948 9.06595 20.0113H14.934C14.99 19.8948 15.0322 19.7699 15.0585 19.6383L15.1763 18.2501Z"
				fill="currentColor"
			/>
			<path
				d="M11 2.99927V1.99927C11 1.44698 11.4477 0.999268 12 0.999268C12.5523 0.999268 13 1.44698 13 1.99927V2.99927C13 3.55155 12.5523 3.99927 12 3.99927C11.4477 3.99927 11 3.55155 11 2.99927Z"
				fill="currentColor"
			/>
			<path
				d="M22 10.9993C22.5523 10.9993 23 11.447 23 11.9993C23 12.5516 22.5523 12.9993 22 12.9993H21C20.4477 12.9993 20 12.5516 20 11.9993C20 11.447 20.4477 10.9993 21 10.9993H22Z"
				fill="currentColor"
			/>
			<path
				d="M3 10.9993C3.55228 10.9993 4 11.447 4 11.9993C4 12.5516 3.55228 12.9993 3 12.9993H2C1.44772 12.9993 1 12.5516 1 11.9993C1 11.447 1.44772 10.9993 2 10.9993H3Z"
				fill="currentColor"
			/>
			<path
				d="M18.3633 4.22095C18.7538 3.83043 19.3868 3.83046 19.7773 4.22095C20.1679 4.61147 20.1679 5.24448 19.7773 5.63501L19.0703 6.34204C18.6798 6.73257 18.0468 6.73256 17.6562 6.34204C17.2658 5.95152 17.2657 5.31849 17.6562 4.92798L18.3633 4.22095Z"
				fill="currentColor"
			/>
			<path
				d="M4.22266 4.22192C4.61318 3.8314 5.24619 3.8314 5.63672 4.22192L6.34375 4.92896C6.73427 5.31948 6.73427 5.95249 6.34375 6.34302C5.95323 6.73354 5.32021 6.73354 4.92969 6.34302L4.22266 5.63599C3.83213 5.24546 3.83213 4.61245 4.22266 4.22192Z"
				fill="currentColor"
			/>
		</svg>
	);
}

IdeaStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default IdeaStrokeIcon;
